import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-book-open-line text-xl text-primary-500"></i>
              </div>
              <span className="font-heading text-lg text-foreground-900 font-bold">89890漫画网</span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">
              免费阅读洞洞杂货铺下拉式漫画，完整章节在线畅读，滑动阅读便捷省力，让追漫成为一种享受。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-900 font-bold mb-4">
              热门分类
            </h4>
            <ul className="space-y-2">
              <li><Link to="/category/rexue" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">热血漫画</Link></li>
              <li><Link to="/category/gaoxiao" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">搞笑漫画</Link></li>
              <li><Link to="/category/lianai" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">恋爱漫画</Link></li>
              <li><Link to="/category/qihuan" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">奇幻漫画</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-900 font-bold mb-4">
              热门漫画
            </h4>
            <ul className="space-y-2">
              <li><Link to="/article/dongdong-zahuopu/ch-001" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">洞洞杂货铺</Link></li>
              <li><Link to="/article/rexue-lanqiu/ch-601" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">热血篮球</Link></li>
              <li><Link to="/article/gaoxiao-riji/ch-401" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">搞笑日记</Link></li>
              <li><Link to="/article/jianhun/ch-201" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">剑魂</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base text-foreground-900 font-bold mb-4">
              关于我们
            </h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">品牌介绍</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">联系我们</Link></li>
            </ul>
            <div className="flex items-center gap-4 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-500 hover:bg-primary-100 hover:text-primary-500 transition-colors cursor-pointer" rel="nofollow" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-500 hover:bg-primary-100 hover:text-primary-500 transition-colors cursor-pointer" rel="nofollow" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-500 hover:bg-primary-100 hover:text-primary-500 transition-colors cursor-pointer" rel="nofollow" aria-label="QQ">
                <i className="ri-qq-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-background-200/70 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; 2026 89890漫画网 版权所有 | 本站所有漫画均来自互联网，仅供学习交流使用
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer" rel="nofollow">服务条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors cursor-pointer" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}